import BaseNetwork from "@/lib/classes/BaseNetwork";
import { derivePubkeyFromSpub } from "@/lib/helpers/derive";
import bs58 from "bs58";

class SOL extends BaseNetwork {
  constructor(xpub: string) {
    super("SOL", xpub);
  }

  getAddress(index: number, derivationPath: number[], spub: string): string {
    const pubkey = derivePubkeyFromSpub(spub, [...derivationPath, index]);

    if (pubkey.derived.length !== 32) {
      throw new Error("Invalid public key length. Expected 32 bytes.");
    }
    const address = bs58.encode(pubkey.derived);

    return address;
  }
}

export default SOL;
